import React from 'react';
import NoDataRow from "../../../../../components/reports/no-data-row.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const EncounterContent = ({ garrison, boName, showDetails }) => {
    if (!showDetails) return null;
    const data = garrison?.encounterData;
    const navigate = navigateHook();

    return (
        <tr>
            <td colSpan={12} style={{ padding: 0 }}>
                <table className="w-full my-4">
                    <thead>
                        <tr>
                            <th colSpan={7} className="headerTitle text-zinc-600">
                                Abordagens do plantão
                                <span className="xRayPath">
                                    <a onClick={() => ReportUtils.openXRay(navigate, 'encounter_x_ray', garrison)}>Acessar Raio X de abordagens</a>
                                </span>
                            </th>
                        </tr>

                        <tr className={'divisor-header text-zinc-600'}>
                            <th className={'w-[15%]'}>D/H da abordagem</th>
                            <th className={'w-[13%]'}>Abordado por</th>
                            <th className={'w-[10%]'}>Status</th>
                            <th className={'w-[10%]'}>Indivíduos</th>
                            <th className={'w-[10%]'}>Veículos</th>
                            <th className={'w-[12%]'}>{boName}</th>
                            <th className={'w-[28%]'}>Justificativa</th>
                        </tr>
                    </thead>

                    <tbody>
                        {!data?.length ? (
                            <NoDataRow colSpan={7} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : data.map((element, index) => (
                            <tr key={index} style={{borderBottom: '1px solid #e7eaec'}}>
                                <td className={'w-[15%]'}>{element.dt_start}</td>
                                <td className={'w-[13%]'}>{element.namewar}</td>
                                <td className={'w-[10%]'}>{element.status_text}</td>
                                <td className={'w-[10%]'}>{element.individuals_count}</td>
                                <td className={'w-[10%]'}>{element.vehicles_count}</td>
                                <td className={'w-[12%]'}>{element.bogcmid}</td>
                                <td className={'w-[28%]'}>{element.justification}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default EncounterContent;